// Every time a person reads is India Standard Time.
//
// The server stores UTC and sends it without a zone ("2026-09-25T05:03:00"),
// and the screens printed that string as it came — so a sign-off made at 10:33
// in Pune read 05:03. Where a screen did parse it, `new Date()` read a zoneless
// string as the BROWSER's local time, which is wrong on any machine not set to
// UTC. Both are fixed here: zoneless timestamps are UTC, and the display zone
// is Asia/Kolkata whatever the viewer's machine says.
//
// Calendar dates ("2026-09-25" — a Zoho invoice date, an inquiry deadline) are
// not moments and are returned untouched: converting midnight UTC would be
// right today and wrong the day someone enters a date west of Greenwich.

const IST = "Asia/Kolkata";
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const HAS_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

function toDate(v) {
  if (v === null || v === undefined || v === "") return null;
  if (v instanceof Date) return v;
  if (typeof v === "number") return new Date(v);
  const s = String(v).trim().replace(" ", "T").replace(/(\.\d{3})\d+/, "$1");
  return new Date(HAS_ZONE.test(s) ? s : s + "Z");
}

const parts = (d, opts) =>
  Object.fromEntries(new Intl.DateTimeFormat("en-GB", { timeZone: IST, ...opts })
    .formatToParts(d).map(p => [p.type, p.value]));

/** "2026-09-25 10:33" in IST. `mode` "date" gives "2026-09-25". "—" if empty. */
export function fmtIST(v, mode = "datetime") {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "string" && DATE_ONLY.test(v.trim())) return v.trim();
  const d = toDate(v);
  if (!d || isNaN(d)) return String(v);
  const p = parts(d, { year: "numeric", month: "2-digit", day: "2-digit",
                       hour: "2-digit", minute: "2-digit", hour12: false });
  const day = `${p.year}-${p.month}-${p.day}`;
  return mode === "date" ? day : `${day} ${p.hour === "24" ? "00" : p.hour}:${p.minute}`;
}
